var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define('maps/track-map',["require", "exports", "../geo/latlng", "../places/places", "../tracks/track-state", "../tracks/track-store", "./basemap", "./layers/focuslayer", "./layers/placeslayer", "./layers/tracklabelslayer", "./layers/tracklayer"], function (require, exports, latlng_1, places, trackState, trackStore, basemap_1, focuslayer_1, placeslayer_1, tracklabelslayer_1, tracklayer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var map;
    var trackLayer;
    var labelsLayer;
    var focusLayer;
    var mapFocusLabel;
    /**
     * Load track data, then initialize map
     */
    function init(trackId, userId) {
        return __awaiter(this, void 0, void 0, function () {
            var track, center, zoom, sw, ne;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapFocusLabel = document.getElementById("map-focus-label");
                        return [4 /*yield*/, trackStore.getTrackData(trackId)];
                    case 1:
                        track = _a.sent();
                        center = track.center();
                        zoom = 16;
                        if (!center) {
                            center = { lat: 39, lng: -100 }; // USA
                            zoom = 4;
                        }
                        // Init map
                        map = new basemap_1.BaseMap({
                            center: center,
                            draggableCursor: "crosshair",
                            maxZoom: 18,
                            zoom: zoom
                        });
                        map.initGoogle(document.getElementById("map"));
                        map.addLayer(trackLayer = new tracklayer_1.TrackLayer(track));
                        map.addLayer(labelsLayer = new tracklabelslayer_1.TrackLabelsLayer(track));
                        map.addLayer(focusLayer = new focuslayer_1.FocusLayer());
                        if (track.place) {
                            map.addLayer(new placeslayer_1.PlacesLayer([track.place]));
                        }
                        // Show nearby places
                        places.getNearby(center, userId).then(function (nearby) {
                            map.addLayer(new placeslayer_1.PlacesLayer(nearby));
                        });
                        sw = { lat: track.stats.lat.min, lng: track.stats.lng.min };
                        ne = { lat: track.stats.lat.max, lng: track.stats.lng.max };
                        if (map.googleMap) {
                            map.googleMap.fitBounds(new google.maps.LatLngBounds(sw, ne));
                        }
                        // Start an async request for max zoom level, in case we're too close
                        updateMaxZoom(sw);
                        // Listen for mouse moves over the map and update the focus label
                        map.onMouseMove(function (ll) { return updateFocusLabel(ll); });
                        // Listen for updates
                        trackState.focusUpdates.subscribe(function (point) { return drawFocus(point); });
                        trackState.trimUpdates.subscribe(function () { return updateMap(); });
                        trackState.labelUpdates.subscribe(function () { return updateMap(); });
                        updateMap();
                        return [2 /*return*/];
                }
            });
        });
    }
    exports.init = init;
    function updateMaxZoom(point) {
        // Only applies to google map
        if (map.googleMap) {
            var maxZoomService = new google.maps.MaxZoomService();
            maxZoomService.getMaxZoomAtLatLng(point, function (response) {
                if (response.status === google.maps.MaxZoomStatus.OK) {
                    // Zoom out if we are too close
                    var mapZoom = map.googleMap && map.googleMap.getZoom();
                    if (mapZoom !== undefined && response.zoom < mapZoom) {
                        map.setZoom(response.zoom);
                    }
                }
            });
        }
    }
    function updateMap() {
        trackLayer.update();
        labelsLayer.update();
    }
    function drawFocus(point) {
        updateFocusLabel(point);
        focusLayer.setFocus(point);
    }
    function updateFocusLabel(point) {
        if (mapFocusLabel) {
            if (point !== undefined) {
                mapFocusLabel.innerText = (0, latlng_1.formatLatLng)(point);
            }
            else {
                mapFocusLabel.innerHTML = "&nbsp;";
            }
        }
    }
});
//# sourceMappingURL=/assets/javascripts/maps/track-map.js.map;
